import { IReconciliationItem } from '@nkr/models/index';
import { IExtendedDashMatch } from './extended-dash-match';
import { ReconciliationItemStatus } from './reconciliation-item-status';

export interface IExtendedReconciliationItem extends IReconciliationItem {
    index: number,
    newEntry: boolean,
    status: ReconciliationItemStatus,
    matches: IExtendedDashMatch[]
}